import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import 'swiper/css/effect-coverflow';

import {EffectCoverflow, Navigation, Pagination } from "swiper";
import './Carousel.css';

import image1 from "./1.jpeg";
import image2 from "./2.jpeg";
import image3 from "./3.jpeg";
import image4 from "./4.jpeg";
import image5 from "./5.jpeg";

function Carousel() {
  return (
    <div className="carousel-container">
      <h1 className="heading">WHAT ARE WE</h1>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        slidesPerView={'auto'}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
        }}
        pagination={{ el: '.swiper-pagination', clickable: true }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          clickable: true,
        }}
        modules={[EffectCoverflow, Pagination, Navigation]}
        className="swiper_container"
      >
        <SwiperSlide>
          <img src="Slice 1.jpg" alt="slide_image" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="Slice 2.png" alt="slide_image" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="Slice 4.jpg" alt="slide_image" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="Slice 3.jpg" alt="slide_image" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="Slice 5.jpg" alt="slide_image" />
        </SwiperSlide>
        {/* <SwiperSlide>
          <img src="Slice 1.jpg" alt="slide_image" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="Slice 2.png" alt="slide_image" />
        </SwiperSlide> */}

        <div className="slider-controler">
          <div className="swiper-button-prev slider-arrow">
            <ion-icon name="arrow-back-outline"></ion-icon>
          </div>
          <div className="swiper-button-next slider-arrow">
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </div>
          <div className="swiper-pagination"></div>
        </div>
      </Swiper>
    </div>
  );
}

export default Carousel;